import { Component, Injector, OnInit, inject, viewChild } from '@angular/core';
import {
  idNameItem,
  JkBaseOption,
  JkComboboxComponent,
  JkdaterangeComponent,
  PageKind,
} from 'jk-service';
import { RowClickedEvent } from 'ag-grid-community';
import { stklg002List, stklg039List, stkmmOrderList, StkmmService, } from '../_service_stk';
import { JkbbchartComponent } from "../components/jkbbchart/jkbbchart.component";
import { MaterialModule, } from 'jk-service';
import { AdvComModule, jkQueryComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';
import { JkbtneditComponent, JkmultiselectComponent } from 'jk-advcom';


class Stkpq14Option extends JkBaseOption {
  date1: string = '';
  date2: string = '';
  frequency: string = '日線'; // 資料頻率
  stklg039: string = '';
  //stkme001: string = '*';
  stkmm002: idNameItem[] = [];
  stkmm003: idNameItem[] = [];
  order: string = '';
  constructor(programId: string) {
    super(programId);
  }
  override init() {
    super.init();
    /*orm.getopenwin('CMSMV','W01','W')
      .subscribe((data) => {
        this.userList = data;
      });
    */
  }
}



@Component({
  selector: 'app-stkpq14',
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, AdvComModule,
    JkbbchartComponent],
  templateUrl: './stkpq14.component.html',
  styleUrl: './stkpq14.component.css',
})
export class Stkpq14Component extends jkQueryComponent implements OnInit {
  stkmmSrv = inject(StkmmService);


  override _programId = 'stkpq14'; // ###
  filterOpt: Stkpq14Option = new Stkpq14Option(this.programId); //###
  readonly stkme001 = viewChild.required<JkbtneditComponent>('stkme001'); // 群組代號
  readonly stkmm004 = viewChild.required<JkdaterangeComponent>('stkmm004'); // 日期
  readonly stkmm002 = viewChild.required<JkmultiselectComponent>('stkmm002'); // 條件代號
  readonly stkmm003 = viewChild.required<JkmultiselectComponent>('stkmm003'); // 股票代號
  readonly stklg002 = viewChild.required<JkComboboxComponent>('stklg002'); // 資料頻率
  readonly stklg039 = viewChild.required<JkComboboxComponent>('stklg039'); // SMA60 方向
  readonly cboOrder = viewChild.required<JkComboboxComponent>('orderby');
  _groupno: string = '*'; // stkme001
  get groupno(): string {
    return this._groupno;
  }
  set groupno(value: string) {
    this._groupno = value;
    this.doImportStkme();
  }
  stockno: string = '';
  //stkmeList: idNameItem[] = [];
  orderList: idNameItem[] = stkmmOrderList;
  stklg002List: idNameItem[] = stklg002List;
  stklg039List: idNameItem[] = stklg039List;
  constructor() {
    super();
    this.setFormOpt2(); //###

    this.logMessage = '';
    //this.addOpenwinLoadOption('#STKME', 'W01', 'W', [], this.stkmeList);
  }
  override ngOnInit() {
    super.ngOnInit();
  }
  override getLookup(): void {
    super.getLookup();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    this.doImportStkme();
    this.cboOrder().itemIndex = 1;
    const sql = `SELECT TOP 1 MM004 FROM STKMM ORDER BY MM004 DESC `;
    this.orm.simpleSql(this.host, sql).subscribe((data: any) => {
      this.filterOpt.date2 = data[0].MM004;
      this.filterOpt.date1 = this.filterOpt.date2; // this.page.countDate(this.filterOpt.date2,'D', -1);
      this.cdr.markForCheck();
    });
    //this.filterOpt.date2 = await this.stkmmSrv.getLastDay();
    //this.filterOpt.date1 = this.page.countDate(this.filterOpt.date2,'D', -3);

  }
  override async beforeQuery(): Promise<boolean> {
    await super.beforeQuery();
    //await this.init(this.programId,'S01','S',['LG001','LG002','LG003','LG004'],[]);
    let orderIndex = this.cboOrder().itemIndex;
    /* {'id':'ORDER BY MM004 DESC,MM003,MM002','name':'依日期倒序+股票代號+條件代號'},
  {'id':'ORDER BY MM003,MM004 DESC,MM002','name':'依股票代號+日期倒序+條件代號'},
  {'id':'ORDER BY MM002,MM003,MM004 DESC','name':'依條件代號+股票代號+日期倒序'},*/
    if (orderIndex === 0) this.winItem = 'S01';
    if (orderIndex === 1) this.winItem = 'S02';
    if (orderIndex === 2) this.winItem = 'S03';

    this.gridInitOpt = {
      pageKind: PageKind.report,
      programId: this.programId,
      sortField: '',
      sort: 'asc',
      defaultSort: null,
    };
    this.type = 'S';
    this.mainTable = this.programId; //['LG001','LG002','LG003','LG004'];
    this.where = '';
    this.where = this.stkmm004().addWhere(this.where, 'MM004');
    this.where = this.stkmm002().addWhere(this.where, 'MM002');
    //this.where = this.stklg002.addWhere(this.where, 'LG002');
    this.where = this.stklg039().addWhere(this.where, 'LG039');
    this.where = this.stkmm003().addWhere(this.where, 'MM003');
    this.order = this.filterOpt.order;
    return true;
  }
  // 以下為自訂的方法
  override agRowClicked($event: RowClickedEvent<any, any>) {
    let r = $event.data;
    if (!r) return;
    if (this.chartVisible) {
      this.stockno = r.MM003;
    }
  }

  doImportStkme() {
    //this.stkmm003.values = [];
    let sql = `SELECT MF002,MA002 FROM STKMF
    LEFT JOIN STKMA ON MF002=MA001
    WHERE MF001='${this.stkme001().value}' ORDER BY MF002 `;
    this.orm.simpleSql(this.host, sql).subscribe((data: any) => {
      this.stkmm003().onValuesChange(data.map((item: any) => {
        return { id: item.MF002, name: item.MA002 };
      }));
      // console.log(this.stkmm003.values);
    });
  }
  chartVisible: boolean = false;
  toggleChartVisible() {
    this.chartVisible = !this.chartVisible;
  }

}
